import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  Button,
  Select,
  Layout
} from 'antd'
import Header from '../Header'
import API from '../../api/index'

const { Content } = Layout

const CategoryUpdate = (props) => {
  const [redirect, setRedirect] = React.useState(undefined)
  const [name, setName] = React.useState(undefined)
  const [errorName, setErrorName] = React.useState(undefined)
  const [nameProps, setNameProps] = React.useState(undefined)
  const [sections, setSections] = React.useState([])
  const [errorSections, setErrorSections] = React.useState(undefined)
  const [listSections, setListSections] = React.useState([])
  const id = props.match.params.id

  const onBack = () => {
    setRedirect('/category')
  }

  const onSubmit = async () => {
    clearErrors()
    let resultName
    if (nameProps !== name) {
      resultName = name
    }
    const response = await API.category.update(id, {
      name: resultName,
      sections: sections
    })
    if (response.ok) {
      Modal.success({
        title: 'Actualización de una categoría',
        content: `La categoría ${name} fue actualizada exitosamente`
      })
      clearErrors()
    }
    if (response.errors) {
      makeErrors(response.errors)
    }
  }

  const makeErrors = (error) => {
    if (error.name) {
      setErrorName(error.name.message)
    }
    if (error.sections) {
      setErrorSections(error.sections.message)
    }
  }

  const clearErrors = () => {
    setErrorName(undefined)
    setErrorSections(undefined)
  }

  const createRow = (values) => {
    let row = []
    values.map(value => {
      return row.push(<Select.Option value={value._id} key={value._id}>{value.name}</Select.Option>)
    })
    return row
  }

  const getCategory = async () => {
    const category = await API.category.detail(id)
    setName(category.name)
    setNameProps(category.name)
    let sections = []
    category.sections.forEach(section => {
      sections.push(section._id)
    })
    setSections(sections)
  }

  const Sections = async () => {
    const sections = await API.sections.product()
    setListSections(sections)
  }

  React.useEffect(() => {
    getCategory()
    Sections()
  }, [])

  
  if (redirect) {
    return (
      <Redirect to={redirect} />
    )
  }
  const ListSections = createRow(listSections)
  return (
    <Layout className='layout'>
      <Header item='category' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <h3><strong>Actualización de categoría</strong></h3>
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <Button onClick={() => onBack()}>Regresar</Button>
              {' '}
              <Button onClick={() => onSubmit()}>Editar</Button>
            </Col>
          </Row>
          <Form
            layout='vertical'
          >
            <Row>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Nombre'
                  validateStatus={errorName && ('error')}
                  help={errorName}
                >
                  <Input
                    type='text'
                    name='name'
                    placeholder='Ingrese nombre de la categoría'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Escoger una sección'
                  validateStatus={errorSections && ('error')}
                  help={errorSections}
                >
                  <Select
                    type='text'
                    mode='multiple'
                    style={{ width: '100%' }}
                    placeholder='Seleccione una sección'
                    onChange={(value) => setSections(value)}
                    value={sections}
                  >
                    {ListSections}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </Layout>
  )
}

export default CategoryUpdate
